import type { FormVersion } from "../state/formVersion";
import { useFormVersionState } from "../state/formVersion";
import type { Form } from "../state/form";
import { useFormDispatch, useFormState } from "../state/form";
import { initialized } from "../utils/initializedUtil";
import ApiService from "./ApiService";
import type { SetStoreFunction } from "solid-js/store";
import { isEmpty } from "lodash-es";
import logger from "../utils/logger";

let formVersionStore: FormVersion | null = null;
let setFormStore: SetStoreFunction<Form> | null = null;
let formStore: Form | null = null;

const init = () => {
  formVersionStore = useFormVersionState();
  formStore = useFormState();
  setFormStore = useFormDispatch();
};

const getFormVersionStore = () => initialized(formVersionStore, "formVersionStore");
const getFormStore = () => initialized(formStore, "formStore");
const getSetFormStore = () => initialized(setFormStore, "setFormStore");

const FormService = {
  getFormId: () => getFormVersionStore().formId,
  getFormVersionId: () => getFormVersionStore().id,
  getFormVersion: () => getFormVersionStore(),
  getForm: () => getFormStore(),
  setFormName: (name: string) => {
    if (isEmpty(name)) {
      throw new Error("Form name cannot be empty");
    }

    // Optimistically update the name
    const previousName = getFormStore().meta.name;
    getSetFormStore()("meta", "name", name);

    ApiService.patchForm(FormService.getFormId()).mutate(
      { meta: { name } },
      {
        onError: (err) => {
          logger.error("Failed to update form name", err);
          getSetFormStore()("meta", "name", previousName);
        },
      },
    );
  },
  setFormDescription: (description: string) => {
    const previousName = getFormStore().meta.description;
    getSetFormStore()("meta", "description", description);

    ApiService.patchForm(FormService.getFormId()).mutate(
      { meta: { description } },
      {
        onError: (err) => {
          logger.error("Failed to update form description", err);
          getSetFormStore()("meta", "description", previousName);
        },
      },
    );
  },
  init,
};

export default FormService;
